module.exports = __webpack_public_path__ + "img/paids.6d08121e.svg";